export default __webpack_public_path__ + "static/media/Video.7f8d05fc.svg";